<template>
    <div class="row">

        <div class="col-md-12 grid-margin stretch-card">

            <div class="card">

                <div class="card-body">

                    <h6 class="card-title">

                        BC 1.1

                    </h6>

                    <div class="mb-12">

                        <label for="defaultconfig" class="col-form-label"> {{ $t('nomor_tutup_pu') }} </label>

                        <div class="row">

                            <div class="col-sm-4">


                                <v-select :options="fetchkodeTutupPu" v-model="kodeTutupPu" label="label" return-object>
                                    <template slot="option" slot-scope="option">
                                        {{ option.label }}
                                    </template>
                                </v-select>

                                <div v-if="this.kodeTutupPu == null || this.kodeTutupPu?.code == ''">
                                    <div class="alert alert-danger" style="padding:5px;"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        Kode Tutup Kosong
                                    </div>
                                </div>

                                <div v-if="errors.kodeTutupPu">
                                    <div v-for="error in errors.kodeTutupPu" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                            <div class="col-sm-4">

                                <input type="text" class="form-control" :id="this.$dynamicId()"
                                    @input="forceUpper($event, forms, 'nomorBc11')" :maxlength="6" v-model="forms.nomorBc11" @blur="handleBlur($event, forms, 'nomorBc11','000000')">

                                    <!-- <div v-if="this.forms?.nomorBc11 == null || this.forms?.nomorBc11 == ''">
                                        <div class="alert alert-danger" style="padding:5px;"
                                            role="alert">
                                            <i data-feather="alert-circle"></i>
                                            Nomor Kosong
                                        </div>
                                    </div> -->

                                <div v-if="errors.nomorBc11">
                                    <div v-for="error in errors.nomorBc11" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                            <div class="col-sm-4">

                                <date-picker v-model="forms.tanggalBc11" input-class="form-control"
                                    placeholder="YYYY-MM-DD" format="YYYY-MM-DD" valueType="format"
                                    type="date"></date-picker>

                                <div v-if="errors.tanggalBc11">
                                    <div v-for="error in errors.tanggalBc11" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                        </div>


                    </div>



                    <div class="mb-12">

                        <label for="defaultconfig" class="col-form-label"> {{ $t('nomor_pos') }} </label>

                        <div class="row">


                            <div class="col-sm-4">

                                <input type="text" class="form-control" :id="this.$dynamicId()"
                                    @input="forceUpper($event, forms, 'posBc11')" :placeholder="$t('nomor_pos')"
                                    v-model="forms.posBc11" :maxlength="4" @blur="handleBlur($event, forms, 'posBc11','0000')">



                                <div v-if="errors.posBc11">
                                    <div v-for="error in errors.posBc11" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>


                            <div class="col-sm-4">

                                <input type="text" class="form-control" :id="this.$dynamicId()"
                                    @input="forceUpper($event, forms, 'subposBc11')" :placeholder="$t('nomor_subpos')"
                                    v-model="forms.subposBc11" :maxlength="4" @blur="handleBlur($event, forms, 'subposBc11','0000')">



                                <div v-if="errors.subposBc11">
                                    <div v-for="error in errors.subposBc11" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                            <div class="col-sm-4">

                                <input type="text" class="form-control" :id="this.$dynamicId()"
                                    @input="forceUpper($event, forms, 'subsubposBc11')"
                                    :placeholder="$t('nomor_subpos')" v-model="forms.subsubposBc11"  :maxlength="4" @blur="handleBlur($event, forms, 'subsubposBc11','0000')">



                                <div v-if="errors.subsubposBc11">
                                    <div v-for="error in errors.subsubposBc11" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                        </div>



                    </div>




                </div>




                <div class="card-body">

                    <h6 class="card-title">

                        {{ $t('pengangkutan') }}

                    </h6>

                    <div class="mb-12">

                        <div class="row">

                            <div class="col-sm-4">

                                <label for="defaultconfig" class="col-form-label required"> {{ $t('cara_pengangkutan')
                                    }}
                                </label>

                                <v-select :options="fetchCaraAngkut" v-model="kodeCaraAngkut" label="label"
                                    return-object>
                                </v-select>

                                <div v-if="this.kodeCaraAngkut == null || this.kodeCaraAngkut?.code == ''">
                                    <div class="alert alert-danger" style="padding:5px;"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        Cara Pengangkutan Kosong
                                    </div>
                                </div>

                                <div v-if="errors.kodeCaraAngkut">
                                    <div v-for="error in errors.kodeCaraAngkut" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                            <div class="col-sm-4">


                                <label class="col-form-label required">{{ $t('nama_sarana_angkut') }}</label>

                                <input type="text" class="form-control" :id="this.$dynamicId()"
                                    v-model="pengangkutan.namaPengangkut"
                                    @input="forceUpper($event, pengangkutan, 'namaPengangkut')" maxlenght="255">

                                    <div v-if="this.pengangkutan?.namaPengangkut == null || this.pengangkutan?.namaPengangkut == ''">
                                        <div class="alert alert-danger" style="padding:5px;"
                                            role="alert">
                                            <i data-feather="alert-circle"></i>
                                            Nomor Sarana Angkut Kosong
                                        </div>
                                    </div>

                                <div v-if="errors.namaPengangkut">
                                    <div v-for="error in errors.namaPengangkut" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                            <div class="col-sm-4">

                                <label class="col-form-label required">{{ $t('no_voy_no_pol') }}</label>

                                <input type="text" class="form-control" :id="this.$dynamicId()"
                                    v-model="pengangkutan.nomorPengangkut"
                                    @input="forceUpper($event, pengangkutan, 'nomorPengangkut')" maxlenght="255">

                                    <div v-if="this.pengangkutan?.namaPengangkut == null || this.pengangkutan?.namaPengangkut == ''">
                                        <div class="alert alert-danger" style="padding:5px;"
                                            role="alert">
                                            <i data-feather="alert-circle"></i>
                                            Nomor Voy/Flight/No.Pol Kosong
                                        </div>
                                    </div>

                                <div v-if="errors.nomorPengangkut">
                                    <div v-for="error in errors.nomorPengangkut" :key="error"
                                        class="alert alert-primary" role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div class="row">
                            <div class="col-sm-4">

                                <label for="defaultconfig" class="col-form-label required"> {{ $t('bendera') }}
                                </label>

                                <v-select :options="fetchKodeBendera" v-model="kodeBendera" label="label" return-object>
                                </v-select>

                                <div v-if="this.kodeBendera == null || this.kodeBendera?.code == ''">
                                    <div class="alert alert-danger" style="padding:5px;"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        Bendera Kosong
                                    </div>
                                </div>

                                <div v-if="errors.kodeBendera">
                                    <div v-for="error in errors.kodeBendera" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>
                            <div class="col-sm-4">

                                <label for="defaultconfig" class="col-form-label required"> {{ $t('perkiraan_tanggal')
                                    }}
                                </label>
                                <br>
                                <date-picker v-model="forms.tanggalTiba" input-class="form-control"
                                    placeholder="YYYY-MM-DD" format="YYYY-MM-DD" valueType="format"
                                    type="date"></date-picker>

                                    <div v-if="this.forms?.tanggalTiba == null || this.forms?.tanggalTiba == ''">
                                    <div class="alert alert-danger" style="padding:5px;"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        Perkiraan Tanggal Tiba kosong
                                    </div>
                                </div>

                                <div v-if="errors.tanggalTiba">
                                    <div v-for="error in errors.tanggalTiba" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                <div class="card-body">

                    <h6 class="card-title">

                        {{ $t('pelabuhan_penimbunan') }}

                    </h6>

                    <div class="mb-12">

                        <div class="row">

                            <div class="col-sm-4">

                                <label for="defaultconfig" class="col-form-label required"> {{ $t('pelabuhan_muat') }}
                                </label>

                                <v-select :options="fetchPelabuhan" v-model="pelabuhanMuat" label="KodePelabuhan" return-object :filter-by="customSearchPel" @search="searchPelabuhan">
                                    <template slot="option" slot-scope="option">
                                        {{ option.KodePelabuhan + " - " + option.Pelabuhan }}
                                    </template>

                                    <template slot="selected-option" slot-scope="option">
                                        {{ option.KodePelabuhan + " - " + option.Pelabuhan }}
                                    </template>
                                </v-select>

                                <div v-if="this.pelabuhanMuat == null || this.pelabuhanMuat?.code == ''">
                                    <div class="alert alert-danger" style="padding:5px;"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        Pelabuhan Muat Kosong
                                    </div>
                                </div>

                                <div v-if="errors.kodePelMuat">
                                    <div v-for="error in errors.kodePelMuat " :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                            <div class="col-sm-4">


                                <label class="col-form-label required">{{ $t('pelabuhan_transit') }}</label>

                                <v-select :options="fetchPelabuhan" v-model="pelabuhanTransit" label="KodePelabuhan" :filter-by="customSearchPel" @search="searchPelabuhan"
                                    return-object>

                                    <template slot="option" slot-scope="option">
                                        {{ option.KodePelabuhan + " - " + option.Pelabuhan }}
                                    </template>

                                    <template slot="selected-option" slot-scope="option">
                                        {{ option.KodePelabuhan + " - " + option.Pelabuhan }}
                                    </template>
                                </v-select>
                                

                                <div v-if="errors.kodePelTransit">
                                    <div v-for="error in errors.kodePelTransit" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                            <div class="col-sm-4">

                                <label class="col-form-label required">{{ $t('pelabuhan_tujuan') }}</label>

                                <v-select :options="fetchPelabuhan" v-model="pelabuhanTujuan" label="label" :filter-by="customSearchPel" @search="searchPelabuhan"
                                    return-object>

                                    <template slot="option" slot-scope="option">
                                        {{ option.KodePelabuhan + " - " + option.Pelabuhan }}
                                    </template>

                                    <template slot="selected-option" slot-scope="option">
                                        {{ option.KodePelabuhan + " - " + option.Pelabuhan }}
                                    </template>
                                </v-select>

                                <div v-if="this.pelabuhanTujuan == null || this.pelabuhanTujuan?.code == ''">
                                    <div class="alert alert-danger" style="padding:5px;"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        Pelabuhan Tujuan Kosong
                                    </div>
                                </div>

                                <div v-if="errors.kodePelTujuan">
                                    <div v-for="error in errors.kodePelTujuan" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div class="row">
                            <div class="col-sm-4">

                                <label for="defaultconfig" class="col-form-label required"> {{ $t('tempat_penimbunan')
                                    }}
                                </label>

                                <v-select :options="fetchTempatTimbun" v-model="tempatTimbun" label="label"
                                    return-object></v-select>

                                <div v-if="this.tempatTimbun == null || this.tempatTimbun?.code == ''">
                                    <div class="alert alert-danger" style="padding:5px;"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        Tempat Timbun Kosong
                                    </div>
                                </div>


                                <div v-if="errors.kodeTps">
                                    <div v-for="error in errors.kodeTps " :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>


            </div>

        </div>
        <div class="col-md-12">

            <a class="nav-link" id="pengangkut-line-tab" data-toggle="tab" href="#pengangkut" role="tab"
                aria-controls="disabled" aria-selected="false">
                <button class="btn btn-info float-end btn-sm" @click="submit()" type="button" :disabled="isLoading">
                    <div v-show="isLoading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                    </div>
                    <div v-show="!isLoading">
                        <i class="link-icon mdi mdi-content-save"></i>
                        {{ $t("save_change_txt") + " " + $t('pengangkut') }}
                    </div>
                </button>
            </a>

        </div>



    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/id';
export default {
    name: "CeisaPengangkut",
    props: {
        propsData: { type: [Object, Array] }
    },
    components: {
        DatePicker
    },
    data() {
        return {
            forms: [],
            kodeTutupPu: { code: "", name: "", label: "" },
            fetchkodeTutupPu: [],
            errors: [],
            pengangkutan: [],
            fetchCaraAngkut: [],
            kodeCaraAngkut: null,
            fetchKodeBendera: [],
            kodeBendera: null,
            fetchPelabuhan: [],
            pelabuhanMuat: null,
            pelabuhanTransit: null,
            pelabuhanTujuan: null,
            fetchTempatTimbun: [],
            tempatTimbun: null,

            isLoading:false,
        }
    },
    methods: {
        handleBlur(e,obj,prop,digit){
            const start = e.target.selectionStart
            e.target.value = this.pad(digit,e.target.value,true);
            this.$set(obj, prop, e.target.value);
            e.target.setSelectionRange(start, start)
            
        },
        pad(pad, str, padLeft) {
            if (typeof str === 'undefined') 
                return pad;
            if (padLeft) {
                return (pad + str).slice(-pad.length);
            } else {
                return (str + pad).substring(0, pad.length);
            }
        },
        customSearchPel(option, label, search){
            let temp = search.toLowerCase();
            return option.KodePelabuhan.toLowerCase().indexOf(temp) > -1 ||
                option.Pelabuhan.toLowerCase().indexOf(temp) > -1
        },
        submit() {
            this.isLoading = true;
            var sendData = {
                document_id: this.propsData?.document_id,
                kodeTutupPu: this.kodeTutupPu?.code ? this.kodeTutupPu?.code : "",
                namaTutupPu: this.kodeTutupPu?.name ? this.kodeTutupPu?.name : "",
                nomorBc11: this.forms?.nomorBc11 ? this.forms?.nomorBc11 : "",
                tanggalBc11: this.forms?.tanggalBc11 ? this.forms?.tanggalBc11 : "",
                tanggalTiba: this.forms?.tanggalTiba ? this.forms?.tanggalTiba : "",
                posBc11: this.forms?.posBc11 ? this.forms?.posBc11 : "",
                subposBc11: this.forms?.subposBc11 ? this.forms?.subposBc11 : "",
                subsubposBc11: this.forms?.subsubposBc11 ? this.forms?.subsubposBc11 : "",
                // kodePelMuat: this.pelabuhanMuat?.code ? this.pelabuhanMuat?.code : "",
                // namaPelMuat: this.pelabuhanMuat?.name ? this.pelabuhanMuat?.name : "",
                kodePelMuat: this.pelabuhanMuat?.KodePelabuhan ? this.pelabuhanMuat?.KodePelabuhan : "",
                namaPelMuat: this.pelabuhanMuat?.Pelabuhan ? this.pelabuhanMuat?.Pelabuhan : "",
                kodePelTransit: this.pelabuhanTransit?.KodePelabuhan ? this.pelabuhanTransit?.KodePelabuhan : "",
                namaPelTransit: this.pelabuhanTransit?.Pelabuhan ? this.pelabuhanTransit?.Pelabuhan : "",
                kodePelTujuan: this.pelabuhanTujuan?.KodePelabuhan ? this.pelabuhanTujuan?.KodePelabuhan : "",
                namaPelTujuan: this.pelabuhanTujuan?.Pelabuhan ? this.pelabuhanTujuan?.Pelabuhan : "",
                kodeTps: this.tempatTimbun?.code ? this.tempatTimbun?.code : "",
                namaTps: this.tempatTimbun?.name ? this.tempatTimbun?.name : "",
                pengangkutan: [
                    {
                        kodeBendera: this.kodeBendera?.code ? this.kodeBendera?.code : "",
                        namaBendera: this.kodeBendera?.name ? this.kodeBendera?.name : "",
                        namaPengangkut: this.pengangkutan?.namaPengangkut ? this.pengangkutan?.namaPengangkut : "",
                        nomorPengangkut: this.pengangkutan?.nomorPengangkut ? this.pengangkutan?.nomorPengangkut : "",
                        kodeCaraAngkut: this.kodeCaraAngkut?.code ? this.kodeCaraAngkut?.code : "",
                        namaCaraAngkut: this.kodeCaraAngkut?.name ? this.kodeCaraAngkut?.name : "",
                        seriPengangkut: 1,
                    }
                ]
            };
            const baseURI = this.$settings.endPointCeisa + "v1/document/store-step-5";
            this.$http.post(baseURI, sendData, { timeout: 10000 }).then((response) => {
                if (response.data.status === 200) {
                    this.loading();
                    this.errors = [];
                    this.success('Berhasil');
                    this.$emit("updateData");
                } else {
                    this.loading();
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                }
            }).catch(error => {
                this.loading();
                if (error.code == "ECONNABORTED") {
                    this.error("Please Check Your Internet Connection");
                }

                if (error.response) {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                        this.logout();
                    } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                    } else {
                        this.$router.push('/page-not-found');
                    }
                }
            });
        },
        forceUpper(e, obj, prop) {
            const start = e.target.selectionStart
            e.target.value = e.target.value.toUpperCase()
            this.$set(obj, prop, e.target.value)
            e.target.setSelectionRange(start, start)
        },
        asyncTempatTimbun() {

            this.fetchTempatTimbun = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=1000&page=1&type=tempatPenimbunan";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;
                    for (var x = 0; x < models.length; x++) {

                        var ob = models[x];
                        var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                        this.fetchTempatTimbun.push(md);
                    }
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        asynckodeCaraAngkut() {

            this.fetchCaraAngkut = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=1000&sort_field=code&sort_type=ASC&page=1&type=kodeCaraAngkut";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;
                    for (var x = 0; x < models.length; x++) {

                        var ob = models[x];
                        var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                        this.fetchCaraAngkut.push(md);
                    }
                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        asyncPelabuhan() {

            this.fetchPelabuhan = [];
            // const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=1000&page=1&type=kodePelabuhan";
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/pelabuhan?limit=100";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    // var models = response.data.datas.data;
                    // for (var x = 0; x < models.length; x++) {

                    //     var ob = models[x];
                    //     var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                    //     this.fetchPelabuhan.push(md);
                    // }
                    if (response.data.datas?.message == 'Sukses') {
                        this.fetchPelabuhan = response.data.datas?.data?.result;
                    } else {
                        this.error("Something Wrong. Code : " + response.data.datas?.code);
                    }

                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        searchPelabuhan(ev,loading){
            loading(true);
            this.fetchPelabuhan = [];
            // const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=1000&page=1&type=kodePelabuhan";
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/pelabuhan?limit=100&keyword="+ev;

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {
                    loading(false);
                    // var models = response.data.datas.data;
                    // for (var x = 0; x < models.length; x++) {

                    //     var ob = models[x];
                    //     var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                    //     this.fetchPelabuhan.push(md);
                    // }
                    if (response.data.datas?.message == 'Sukses') {
                        this.fetchPelabuhan = response.data.datas?.data?.result;
                    } else {
                        this.error("Something Wrong. Code : " + response.data.datas?.code);
                    }

                }).catch(error => {
                    loading(false);

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        asynckodeNegara() {

            this.fetchKodeBendera = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=1000&page=1&type=kodeNegara";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {
                    var models = response.data.datas.data;
                    for (var x = 0; x < models.length; x++) {

                        var ob = models[x];
                        var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                        this.fetchKodeBendera.push(md);
                    }

                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        asynckodeTutupPu() {

            this.fetchkodeTutupPu = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=3&page=1&type=kodeTutupPu";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchkodeTutupPu.push(md);
                        }


                    }



                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        backForm() {
            window.location.href = "/exim/ceisa/dokumen-pabean";
        },
        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },
        reAssignValue() {
            this.kodeTutupPu = { code: this.forms.kodeTutupPu, name: this.forms.namaTutupPu, label: this.forms.kodeTutupPu + " - " + this.forms.namaTutupPu };
            this.pelabuhanMuat = { KodePelabuhan: this.forms.kodePelMuat, Pelabuhan: this.forms.namaPelMuat, label: this.forms.kodePelMuat + " - " + this.forms.namaPelMuat };
            this.pelabuhanTujuan = { KodePelabuhan: this.forms.kodePelTujuan, Pelabuhan: this.forms.namaPelTujuan, label: this.forms.kodePelTujuan + " - " + this.forms.namaPelTujuan };
            this.pelabuhanTransit = { KodePelabuhan: this.forms.kodePelTransit, Pelabuhan: this.forms.namaPelTransit, label: this.forms.kodePelTransit + " - " + this.forms.namaPelTransit };
            this.tempatTimbun = { code: this.forms.kodeTps, name: this.forms.namaTps, label: this.forms.kodeTps + " - " + this.forms.namaTps };
            var pengangkut = this.forms.pengangkut;

            if(this.forms.tanggalBc11 == "0000-00-00"){
                this.forms.tanggalBc11 = "";
            }
            if (pengangkut) {
                if (pengangkut.length > 0) {
                    for (var x = 0; x < pengangkut.length; x++) {
                        var ob = pengangkut[x];
                        this.kodeCaraAngkut = { code: ob?.kodeCaraAngkut, name: ob?.namaCaraAngkut, label: ob?.kodeCaraAngkut + " - " + ob?.namaCaraAngkut };
                        this.kodeBendera = { code: ob?.kodeBendera, name: ob?.namaBendera, label: ob?.kodeBendera + " - " + ob?.namaBendera };
                        this.pengangkutan.namaPengangkut = ob?.namaPengangkut;
                        this.pengangkutan.nomorPengangkut = ob?.nomorPengangkut;
                    }
                }
            }

        },
    },
    watch: {
        propsData: function (newVal) {
            this.forms = newVal;
            this.reAssignValue();
        },
        forms: function (newVal) {
            this.$emit('formUpdate', newVal);
        },
    },
    created() {
        this.asynckodeTutupPu();
        this.asynckodeCaraAngkut();
        this.asynckodeNegara();
        this.asyncPelabuhan();
        this.asyncTempatTimbun();
    }
}
</script>

<style></style>